import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Pageheader from '../utils/headerHelment';
import IntelligenceInsights from '../components/LensIntelligence/IntelligenceInsights';
import { isLensIntelligenceEnabled } from '../utils/lensFeatures';
import styles from '../components/LensIntelligence/lensIntelligence.module.css';

const LensIntelligenceInsightsView = () => {
    const { selectedProject } = useSelector(state => state.projectData);

    if (!isLensIntelligenceEnabled(selectedProject)) {
        return <Navigate to="/project" replace />;
    }

    return (
        <div className={styles.pageRoot}>
            <Pageheader title="LENS - Intelligence Insights" />
            <IntelligenceInsights />
        </div>
    );
};

export default LensIntelligenceInsightsView;
